import React, { FC } from 'react';
import PreventLandscapeOverlay from 'components/PreventLandscapeOverlay';
import { useTheme } from 'contexts/ThemeContext';
import LandingLayout from '../LandingLayout';
import SuccessStorySection from './SuccessStory';
import TopExpertsContest from './TopExpertsContest';
import AwardsSection from './AwardsSection';
import LifeSection from './LifeSection';
import WorkSection from './WorkSection';
import SafeSection from './SafeSection';
import ItsTimeSection from './ItsTimeSection/ItsTimeSection';
import style from './CommonLandingPage.module.scss';

const CommonLandingPage: FC = () => {
    const { theme } = useTheme();

    return (
        <div className={`${style.landingPage} ${style[theme]}`}>
            <PreventLandscapeOverlay />
            <LandingLayout>
                <SuccessStorySection />
                <TopExpertsContest />
                <AwardsSection />
                <LifeSection />
                <WorkSection />
                <SafeSection />
                <ItsTimeSection />
            </LandingLayout>
        </div>
    );
};

export default CommonLandingPage;
